export function checkTitleComplexity(title: string, maxWordsLength = 20) {
  return title.split(' ').some((word) => word.length > maxWordsLength);
}
